import { User as UserNode } from "@acto/gql/graphql";
import Employee from "./Employee";

type UserData = Pick<UserNode, "id" | "name"> & {
  employee?: { id: string; name: string } | null;
};

/**
 * A person as an Acto login. Distinct from [Employee], which the customer's ERP describes: records
 * the product creates belong to a user, while revenue and org structure hang off an employee.
 */
export default class User {
  constructor(
    public readonly id: string,
    /** The name on the login, which the identity provider often leaves unset. */
    public readonly name?: string | null,
    /**
     * The ERP record describing this user. Absent when the query didn't select it; null when the
     * ERP does not describe them.
     */
    public readonly employee?: Employee | null,
  ) {}

  get displayName(): string | null {
    return this.employee?.name ?? this.name ?? null;
  }

  static fromGraphql(data: UserData): User {
    return new User(data.id, data.name ?? null, data.employee ? Employee.fromGraphql(data.employee) : null);
  }
}
